module.exports = __webpack_public_path__ + "images/kihnu/routes/MAN-MUN-MAN.png";